/**
 * drl-hero-banner JS
 */

import $ from 'jquery';

Drupal.behaviors.drl_hero_banner = {
  attach(context) {
    // Herro Banner Style 6 show function
    $('.drl-hero-banner-warpper .show', context).on('click', function show() {
      $(this)
        .closest('.drl-hero-banner-warpper')
        .find('.milestone-details-section')
        .fadeIn('slow');
    });

    // Herro Banner Style 6 hide function
    $('.drl-hero-banner-warpper .hide', context).on('click', function show() {
      $(this)
        .closest('.drl-hero-banner-warpper')
        .find('.milestone-details-section')
        .fadeOut('slow');
    });
  },
};

Drupal.behaviors.purpleCardAnimate = {
  attach: function () {
    var didScroll;
    var lastScrollTop = 0;

    $(window).scroll(function (event) {
      didScroll = true;
    });

    setInterval(function () {
      if (didScroll) {
        if ($('body').find('#sticky-content').length > 0) {
          hasScrolled();
          didScroll = false;
        }
      }
    }, 250);

    function hasScrolled() {
      var st = $(window).scrollTop();
      var viewportTop = Math.round($(window).scrollTop());
      var elemTop = Math.round($('#sticky-content').offset().top);
        if (elemTop <= viewportTop) {
          $('#sticky-content').addClass('in-view');
        } else {
          $('#sticky-content').removeClass('in-view');
        }
      lastScrollTop = st;
    }
  }
};
